import List from "@material-ui/core/List";

import React, { useMemo, useState } from "react";
import {
  CheckoutCardContent,
  CheckoutCardList,
  CheckoutCardSubHeader,
} from "./CheckoutCard";
import { Trans, useTranslation } from "react-i18next";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import FormikTextField from "../../../components/Common/FormikTextField";
import { getYUPValidators } from "../../../components/yupvalidators";
import ListItemRadioButton from "../../../components/Common/ListItemRadioButton";
import { useCheckout } from "../../providers/CheckoutProvider";
import { useAuth } from "../../providers/AuthProvider";
import CardContent from "@material-ui/core/CardContent";

export default ({ deliveryMethod }) => {
  const { deliveryOptionData } = useCheckout();

  console.log("Delivery option data", deliveryOptionData);

  const { user } = useAuth();
  const { t } = useTranslation();
  const { setDeliveryOption } = useCheckout();
  console.log("The user", user);

  const deliveryOptions = useMemo(() => {
    return deliveryMethod.deliveryOptions.reduce(
      (deliveryOptions, deliveryOption) => {
        const subjects = deliveryOption.subjects.map((subject) => {
          return {
            subject: {
              name: subject.name,
              uuid: subject.uuid,
              group: subject.group,
            },
            name: deliveryOption.name,
            uuid: deliveryOption.uuid,
            type: deliveryMethod.type,
            price: deliveryOption.price,
            expire: deliveryOption.expire,
          };
        });
        return [...deliveryOptions, ...subjects];
      },
      []
    );
  }, [deliveryMethod]);
  const [currentDeliveryOption, setCurrentDeliveryOption] = useState(
    deliveryOptions.length > 0 ? deliveryOptions[0] : null
  );

  return (
    <>
      <CheckoutCardContent>
        <CheckoutCardSubHeader>
          <Trans>Order recipient</Trans>
        </CheckoutCardSubHeader>
        <Box mb={0}>
          {deliveryOptions.length > 1
            ? t("Please select who you would like the order delivered to:")
            : t("The order will be delivered to:")}
        </Box>
      </CheckoutCardContent>
      <Formik
        initialValues={{
          name: deliveryOptionData?.contactInfo?.name || user.name,
          emailAddress:
            deliveryOptionData?.contactInfo?.emailAddress || user.emailAddress,
        }}
        validateOnMount={true}
        validationSchema={schema(t)}
        onSubmit={(values, { setSubmitting, setErrors }) => {
          const data = {
            contactInfo: { ...values },
            subject: currentDeliveryOption.subject,
          };
          setDeliveryOption(currentDeliveryOption, data);
        }}
      >
        {({ submitForm, isValid, isSubmitting }) => {
          return (
            <Form>
              <CheckoutCardList>
                {deliveryOptions.map((deliveryOption, idx) => {
                  console.log("Delivery option", deliveryOption);
                  const selected =
                    currentDeliveryOption?.uuid +
                      currentDeliveryOption?.subject?.uuid ==
                    deliveryOption.uuid + deliveryOption.subject?.uuid;

                  return (
                    <ListItemRadioButton
                      key={
                        deliveryOption.uuid + "-" + deliveryOption.subject.uuid
                      }
                      onClick={() => setCurrentDeliveryOption(deliveryOption)}
                      primaryText={`${deliveryOption.subject.group}: ${deliveryOption.subject.name}`}
                      secondaryText={`${deliveryOption.name} - ${sprintf(
                        t("Available through %s"),
                        deliveryOption.expire
                      )}`}
                      selected={selected}
                    />
                  );
                })}
              </CheckoutCardList>
              <CheckoutCardContent>
                <CheckoutCardSubHeader>
                  <Trans>Your contact details</Trans>
                </CheckoutCardSubHeader>

                <Field
                  component={FormikTextField}
                  label={t("Your name")}
                  name="name"
                />

                <Field
                  component={FormikTextField}
                  label={t("Your email address")}
                  name="emailAddress"
                />

                <Box mt={2} display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={!isValid}
                    type="submit"
                  >
                    <Trans>Next step</Trans>
                  </Button>
                </Box>
              </CheckoutCardContent>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

const schema = (t) => () => {
  const validators = getYUPValidators(t);
  return Yup.object().shape({
    name: validators.FULL_NAME.required(t("This is required!")),
    emailAddress: validators.EMAIL_ADDRESS.required(t("This is required!")),
  });
};
